import React, { useEffect, useState } from "react";

function ElectrostaticGridTransformerSVG({
  /* ================= TRANSFORMER ================= */
  tx = 100,
  ty = 100,
  tWidth = 40,
  tHeight = 20,
  tRotation = 0,

  /* ================= LEFT ROD ================= */
  leftX = 80,
  leftY = 70,
  leftWidth = 10,
  leftHeight = 120,
  leftRotation = 0,

  /* ================= RIGHT ROD ================= */
  rightX = 150,
  rightY = 70,
  rightWidth = 10,
  rightHeight = 120,
  rightRotation = 0,

  running = false,
  onClick = () => {},
}) {
  const [intensity, setIntensity] = useState(0);

  /* =====================================================
     COLOR BUILDUP
  ===================================================== */
  useEffect(() => {
    const timer = setInterval(() => {
      setIntensity((prev) => {
        if (running) {
          return Math.min(prev + 2, 100);
        }
        return Math.max(prev - 3, 0);
      });
    }, 120);

    return () => clearInterval(timer);
  }, [running]);

  const red = Math.round(60 + intensity * 1.95);
  const color = `rgb(${red},0,0)`;

  const glow = `drop-shadow(0 0 ${
    2 + intensity / 10
  }px ${color})`;

  return (
    <svg
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        overflow: "visible",
        pointerEvents: "none", // IMPORTANT
      }}
    >
      {/* =====================================================
          LEFT ROD ONLY CLICKABLE
      ===================================================== */}
      <g
        transform={`
          rotate(
            ${leftRotation},
            ${leftX + leftWidth / 2},
            ${leftY + leftHeight / 2}
          )
        `}
      >
        <rect
          x={leftX}
          y={leftY}
          width={leftWidth}
          height={leftHeight}
          rx="2"
          fill={color}
          stroke="#ff4444"
          strokeWidth="1"
          onClick={onClick}
          style={{
            cursor: "pointer",
            pointerEvents: "all",
            filter: glow,
          }}
        />
      </g>

      {/* =====================================================
          RIGHT ROD ONLY CLICKABLE
      ===================================================== */}
      <g
        transform={`
          rotate(
            ${rightRotation},
            ${rightX + rightWidth / 2},
            ${rightY + rightHeight / 2}
          )
        `}
      >
        <rect
          x={rightX}
          y={rightY}
          width={rightWidth}
          height={rightHeight}
          rx="2"
          fill={color}
          stroke="#ff4444"
          strokeWidth="1"
          onClick={onClick}
          style={{
            cursor: "pointer",
            pointerEvents: "all",
            filter: glow,
          }}
        />
      </g>

      {/* =====================================================
          TRANSFORMER BODY ONLY CLICKABLE
      ===================================================== */}
      <g
        transform={`
          rotate(
            ${tRotation},
            ${tx + tWidth / 2},
            ${ty + tHeight / 2}
          )
        `}
      >
        <rect
          x={tx}
          y={ty}
          width={tWidth}
          height={tHeight}
          rx="3"
          fill={color}
          stroke="#ff6666"
          strokeWidth="1"
          onClick={onClick}
          style={{
            cursor: "pointer",
            pointerEvents: "all",
            filter: glow,
          }}
        />
      </g>
    </svg>
  );
}

export default ElectrostaticGridTransformerSVG;